getUserLocalDataLanguageAlertBarAccepted